//user actions
export const UPDATE_LOCATION = '@@router/UPDATE_LOCATION'; // undispatched

//exercises actions
export const SEARCH_EXERCISES = 'SEARCH_EXERCISES';
export const SEARCH_EXERCISES_SUCCESS = 'SEARCH_EXERCISES_SUCCESS';
export const SEARCH_EXERCISES_FAILURE = 'SEARCH_EXERCISES_FAILURE';
export const SEARCH_MORE_EXERCISES = 'SEARCH_MORE_EXERCISES';
export const SEARCH_MORE_EXERCISES_SUCCESS = 'SEARCH_MORE_EXERCISES_SUCCESS';
export const SEARCH_MORE_EXERCISES_FAILURE = 'SEARCH_MORE_EXERCISES_FAILURE';
export const RESET_SEARCH = 'RESET_SEARCH';
export const OPEN_EXERCISE_PREVIEW = 'OPEN_EXERCISE_PREVIEW';
export const RESET_EXERCISES = 'RESET_EXERCISES';
export const FETCH_EXERCISE = 'FETCH_EXERCISE';
export const FETCH_EXERCISE_SUCCESS = 'FETCH_EXERCISE_SUCCESS';
export const FETCH_EXERCISE_FAILURE = 'FETCH_EXERCISE_FAILURE';
export const GET_USER_EXERCISES = 'GET_USER_EXERCISES';
export const GET_USER_EXERCISES_SUCCESS = 'GET_USER_EXERCISES_SUCCESS';
export const GET_USER_EXERCISES_FAILURE = 'GET_USER_EXERCISES_FAILURE';
export const GET_MORE_USER_EXERCISES = 'GET_MORE_USER_EXERCISES';
export const GET_MORE_USER_EXERCISES_SUCCESS = 'GET_MORE_USER_EXERCISES_SUCCESS';
export const GET_MORE_USER_EXERCISES_FAILURE = 'GET_MORE_USER_EXERCISES_FAILURE';
export const SAVE_EXERCISE = 'SAVE_EXERCISE';
export const SAVE_EXERCISE_SUCCESS = 'SAVE_EXERCISE_SUCCESS';
export const SAVE_EXERCISE_FAILURE = 'SAVE_EXERCISE_FAILURE';
export const UPDATE_EXERCISE = 'UPDATE_EXERCISE';
export const UPDATE_EXERCISE_SUCCESS = 'UPDATE_EXERCISE_SUCCESS';
export const UPDATE_EXERCISE_FAILURE = 'UPDATE_EXERCISE_FAILURE';
export const DELETE_EXERCISE = 'DELETE_EXERCISE';
export const DELETE_EXERCISE_SUCCESS = 'DELETE_EXERCISE_SUCCESS';
export const DELETE_EXERCISE_FAILURE = 'DELETE_EXERCISE_FAILURE';

//taxonomy actions
export const GET_CONTENT_TAXONOMY = 'GET_CONTENT_TAXONOMY';
export const GET_CONTENT_TAXONOMY_SUCCESS = 'GET_CONTENT_TAXONOMY_SUCCESS';
export const GET_CONTENT_TAXONOMY_FAILURE = 'GET_CONTENT_TAXONOMY_FAILURE';
export const GET_INVALSI_CONTENT_TAXONOMY = 'GET_INVALSI_CONTENT_TAXONOMY';
export const GET_INVALSI_CONTENT_TAXONOMY_SUCCESS = 'GET_INVALSI_CONTENT_TAXONOMY_SUCCESS';
export const GET_INVALSI_CONTENT_TAXONOMY_FAILURE = 'GET_INVALSI_CONTENT_TAXONOMY_FAILURE';
export const GET_HOMEWORK_CONTENT_TAXONOMY = 'GET_HOMEWORK_CONTENT_TAXONOMY';
export const GET_HOMEWORK_CONTENT_TAXONOMY_SUCCESS = 'GET_HOMEWORK_CONTENT_TAXONOMY_SUCCESS';
export const GET_HOMEWORK_CONTENT_TAXONOMY_FAILURE = 'GET_HOMEWORK_CONTENT_TAXONOMY_FAILURE';

//cart actions
export const ADD_EXERCISE_TO_CART = 'ADD_EXERCISE_TO_CART';
export const ADD_EXERCISES_TO_CART = 'ADD_EXERCISES_TO_CART';
export const REMOVE_EXERCISE_FROM_CART = 'REMOVE_EXERCISE_FROM_CART';
export const CHANGE_HOMEWORK_TITLE = 'CHANGE_HOMEWORK_TITLE';
export const CHANGE_HOMEWORK_DESCRIPTION = 'CHANGE_HOMEWORK_DESCRIPTION';
export const CHANGE_INPUT_STYLE = 'CHANGE_INPUT_STYLE';
export const EMPTY_CART = 'EMPTY_CART';
export const CLOSE_EMPTY_CART_MODAL = 'CLOSE_EMPTY_CART_MODAL';
export const OPEN_EMPTY_CART_MODAL = 'OPEN_EMPTY_CART_MODAL';

//favourite actions
export const GET_FAVOURITE_EXERCISES = 'GET_FAVOURITE_EXERCISES';
export const GET_FAVOURITE_EXERCISES_SUCCESS = 'GET_FAVOURITE_EXERCISES_SUCCESS';
export const GET_FAVOURITE_EXERCISES_FAILURE = 'GET_FAVOURITE_EXERCISES_FAILURE';
export const ADD_EXERCISE_TO_FAVOURITE = 'ADD_EXERCISE_TO_FAVOURITE';
export const ADD_EXERCISE_TO_FAVOURITE_SUCCESS = 'ADD_EXERCISE_TO_FAVOURITE_SUCCESS';
export const ADD_EXERCISE_TO_FAVOURITE_FAILURE = 'ADD_EXERCISE_TO_FAVOURITE_FAILURE';
export const REMOVE_EXERCISE_FROM_FAVOURITE = 'REMOVE_EXERCISE_FROM_FAVOURITE';
export const REMOVE_EXERCISE_FROM_FAVOURITE_SUCCESS = 'REMOVE_EXERCISE_FROM_FAVOURITE_SUCCESS';
export const REMOVE_EXERCISE_FROM_FAVOURITE_FAILURE = 'REMOVE_EXERCISE_FROM_FAVOURITE_FAILURE';
export const GET_FAVOURITE_HOMEWORK = 'GET_FAVOURITE_HOMEWORK';
export const GET_FAVOURITE_HOMEWORK_SUCCESS = 'GET_FAVOURITE_HOMEWORK_SUCCESS';
export const GET_FAVOURITE_HOMEWORK_FAILURE = 'GET_FAVOURITE_HOMEWORK_FAILURE';
export const ADD_HOMEWORK_TO_FAVOURITE = 'ADD_HOMEWORK_TO_FAVOURITE';
export const ADD_HOMEWORK_TO_FAVOURITE_SUCCESS = 'ADD_HOMEWORK_TO_FAVOURITE_SUCCESS';
export const ADD_HOMEWORK_TO_FAVOURITE_FAILURE = 'ADD_HOMEWORK_TO_FAVOURITE_FAILURE';
export const REMOVE_HOMEWORK_FROM_FAVOURITE = 'REMOVE_HOMEWORK_FROM_FAVOURITE';
export const REMOVE_HOMEWORK_FROM_FAVOURITE_SUCCESS = 'REMOVE_HOMEWORK_FROM_FAVOURITE_SUCCESS';
export const REMOVE_HOMEWORK_FROM_FAVOURITE_FAILURE = 'REMOVE_HOMEWORK_FROM_FAVOURITE_FAILURE';
export const GET_FAVOURITE_EDITORIAL_HOMEWORK = 'GET_FAVOURITE_EDITORIAL_HOMEWORK';
export const GET_FAVOURITE_EDITORIAL_HOMEWORK_SUCCESS = 'GET_FAVOURITE_EDITORIAL_HOMEWORK_SUCCESS';
export const GET_FAVOURITE_EDITORIAL_HOMEWORK_FAILURE = 'GET_FAVOURITE_EDITORIAL_HOMEWORK_FAILURE';
export const ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE = 'ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE';
export const ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_SUCCESS = 'ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_SUCCESS';
export const ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_FAILURE = 'ADD_EDITORIAL_HOMEWORK_TO_FAVOURITE_FAILURE';
export const REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE = 'REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE';
export const REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_SUCCESS = 'REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_SUCCESS';
export const REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_FAILURE = 'REMOVE_EDITORIAL_HOMEWORK_FROM_FAVOURITE_FAILURE';

// menu actions
export const OPEN_MENU = 'OPEN_MENU';

// ticker actions
export const GET_TICKER = 'GET_TICKER';
export const GET_TICKER_SUCCESS = 'GET_TICKER_SUCCESS';
export const GET_TICKER_FAILURE = 'GET_TICKER_FAILURE';

// homework actions
export const GET_HOMEWORK_LIST = 'GET_HOMEWORK_LIST';
export const GET_HOMEWORK_LIST_SUCCESS = 'GET_HOMEWORK_LIST_SUCCESS';
export const GET_HOMEWORK_LIST_FAILURE = 'GET_HOMEWORK_LIST_FAILURE';
export const GET_INVALSI_HOMEWORK = 'GET_INVALSI_HOMEWORK';
export const GET_INVALSI_HOMEWORK_SUCCESS = 'GET_INVALSI_HOMEWORK_SUCCESS';
export const GET_INVALSI_HOMEWORK_FAILURE = 'GET_INVALSI_HOMEWORK_FAILURE';
export const GET_MORE_HOMEWORK_LIST = 'GET_MORE_HOMEWORK_LIST';
export const GET_MORE_HOMEWORK_LIST_SUCCESS = 'GET_MORE_HOMEWORK_LIST_SUCCESS';
export const GET_MORE_HOMEWORK_LIST_FAILURE = 'GET_MORE_HOMEWORK_LIST_FAILURE';
export const GET_SPECIAL_HOMEWORK = 'GET_SPECIAL_HOMEWORK';
export const GET_SPECIAL_HOMEWORK_SUCCESS = 'GET_SPECIAL_HOMEWORK_SUCCESS';
export const GET_SPECIAL_HOMEWORK_FAILURE = 'GET_SPECIAL_HOMEWORK_FAILURE';
export const SAVE_HOMEWORK = 'SAVE_HOMEWORK';
export const SAVE_HOMEWORK_SUCCESS = 'SAVE_HOMEWORK_SUCCESS';
export const SAVE_HOMEWORK_FAILURE = 'SAVE_HOMEWORK_FAILURE';
export const SEARCH_EDITORIAL_HOMEWORK = 'SEARCH_EDITORIAL_HOMEWORK';
export const SEARCH_EDITORIAL_HOMEWORK_SUCCESS = 'SEARCH_EDITORIAL_HOMEWORK_SUCCESS';
export const SEARCH_EDITORIAL_HOMEWORK_FAILURE = 'SEARCH_EDITORIAL_HOMEWORK_FAILURE';
export const SEARCH_MORE_EDITORIAL_HOMEWORK = 'SEARCH_MORE_EDITORIAL_HOMEWORK';
export const SEARCH_MORE_EDITORIAL_HOMEWORK_SUCCESS = 'SEARCH_MORE_EDITORIAL_HOMEWORK_SUCCESS';
export const SEARCH_MORE_EDITORIAL_HOMEWORK_FAILURE = 'SEARCH_MORE_EDITORIAL_HOMEWORK_FAILURE';
export const GO_TO_HOMEWORK_DETAIL_PAGE = 'GO_TO_HOMEWORK_DETAIL_PAGE';

//homework detail actions
export const CHANGE_DETAIL_INPUT_STYLE = 'CHANGE_DETAIL_INPUT_STYLE';
export const CHANGE_HOMEWORK_DETAIL_TITLE = 'CHANGE_HOMEWORK_DETAIL_TITLE';
export const CHANGE_HOMEWORK_DETAIL_DESCRIPTION = 'CHANGE_HOMEWORK_DETAIL_DESCRIPTION';
export const GET_HOMEWORK = 'GET_HOMEWORK';
export const GET_HOMEWORK_SUCCESS = 'GET_HOMEWORK_SUCCESS';
export const GET_HOMEWORK_FAILURE = 'GET_HOMEWORK_FAILURE';
export const CLOSE_DELETE_HOMEWORK_MODAL = 'CLOSE_DELETE_HOMEWORK_MODAL';
export const OPEN_DELETE_HOMEWORK_MODAL = 'OPEN_DELETE_HOMEWORK_MODAL';
export const CLOSE_CANCEL_HOMEWORK_MODAL = 'CLOSE_CANCEL_HOMEWORK_MODAL';
export const OPEN_CANCEL_HOMEWORK_MODAL = 'OPEN_CANCEL_HOMEWORK_MODAL';
export const DELETE_HOMEWORK = 'DELETE_HOMEWORK';
export const DELETE_HOMEWORK_SUCCESS = 'DELETE_HOMEWORK_SUCCESS';
export const DELETE_HOMEWORK_FAILURE = 'DELETE_HOMEWORK_FAILURE';
export const UPDATE_HOMEWORK = 'UPDATE_HOMEWORK';
export const ADD_EXERCISE_TO_HOMEWORK = 'ADD_EXERCISE_TO_HOMEWORK';
export const ADD_EXERCISES_TO_HOMEWORK = 'ADD_EXERCISES_TO_HOMEWORK';
export const REMOVE_EXERCISE_FROM_HOMEWORK = 'REMOVE_EXERCISE_FROM_HOMEWORK';
export const UPDATE_HOMEWORK_SUCCESS = 'UPDATE_HOMEWORK_SUCCESS';
export const UPDATE_HOMEWORK_FAILURE = 'UPDATE_HOMEWORK_FAILURE';

//homework export actions
export const START_HOMEWORK_EXPORT = 'STAR_HOMEWORK_EXPORT';
export const STOP_HOMEWORK_EXPORT = 'STOP_HOMEWORK_EXPORT';
export const CHANGE_ROW_NUMBER = 'CHANGE_ROW_NUMBER';
export const HIGH_READABILITY_FLAG = 'HIGH_READABILITY_FLAG';
export const CALL_T2P = 'CALL_T2P';
export const CALL_T2P_SUCCESS = 'CALL_T2P_SUCCESS';
export const CALL_T2P_FAILURE = 'CALL_T2P_FAILURE';
export const RESET_FILES_WORD = 'RESET_FILES_WORD';
export const DOWNLOAD_FILES_WORD = 'DOWNLOAD_FILES_WORD';
export const CHECK_FILE_EXISTENCE = 'CHECK_FILE_EXISTENCE';
export const CHECK_FILE_EXISTENCE_SUCCESS = 'CHECK_FILE_EXISTENCE_SUCCESS';
export const CHECK_FILE_EXISTENCE_FAILURE = 'CHECK_FILE_EXISTENCE_FAILURE';
export const RESET_MESSAGE_ERROR = 'RESET_MESSAGE_ERROR';

//editorial homework actions
export const GET_EDITORIAL_HOMEWORK = 'GET_EDITORIAL_HOMEWORK';
export const GET_EDITORIAL_HOMEWORK_SUCCESS = 'GET_EDITORIAL_HOMEWORK_SUCCESS';
export const GET_EDITORIAL_HOMEWORK_FAILURE = 'GET_EDITORIAL_HOMEWORK_FAILURE';

export const REORDER_EXERCISES = 'REORDER_EXERCISES';
export const REORDER_HOMEWORK_EXERCISES = 'REORDER_HOMEWORK_EXERCISES';

//search form actions
export const GET_SUBJECTS = 'GET_SUBJECTS';
export const GET_SUBJECTS_SUCCESS = 'GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_FAILURE = 'GET_SUBJECTS_FAILURE';
export const GET_BOOKS = 'GET_BOOKS';
export const GET_BOOKS_SUCCESS = 'GET_BOOKS_SUCCESS';
export const GET_BOOKS_FAILURE = 'GET_BOOKS_FAILURE';
export const GET_ITEM_TYPES = 'GET_ITEM_TYPES';
export const GET_ITEM_TYPES_SUCCESS = 'GET_ITEM_TYPES_SUCCESS';
export const GET_ITEM_TYPES_FAILURE = 'GET_ITEM_TYPES_FAILURE';
export const GET_AUTHORS = 'GET_AUTHORS';
export const GET_AUTHORS_SUCCESS = 'GET_AUTHORS_SUCCESS';
export const GET_AUTHORS_FAILURE = 'GET_AUTHORS_FAILURE';
export const SHOW_FILTERS = 'SHOW_FILTERS';
export const EXERCISES_EDITORIAL_FILTERS_CHANGE = 'EXERCISES_EDITORIAL_FILTERS_CHANGE';
export const HOMEWORKS_EDITORIAL_FILTERS_CHANGE = 'HOMEWORKS_EDITORIAL_FILTERS_CHANGE';

//shared text actions
export const FETCH_EXERCISES_BY_RELATED_FATHER = 'FETCH_EXERCISES_BY_RELATED_FATHER';
export const FETCH_EXERCISES_BY_RELATED_FATHER_SUCCESS = 'FETCH_EXERCISES_BY_RELATED_FATHER_SUCCESS';
export const FETCH_EXERCISES_BY_RELATED_FATHER_FAILURE = 'FETCH_EXERCISES_BY_RELATED_FATHER_FAILURE';

//user notification
export const CLEAR_USER_NOTIFICATION = 'CLEAR_USER_NOTIFICATION';
export const CLEAR_ERROR_USER_NOTIFICATION = 'CLEAR_ERROR_USER_NOTIFICATION';

//storage actions
export const REDUX_STORAGE_LOAD = 'REDUX_STORAGE_LOAD';

//invalsi actions
export const GET_INVALSI_SUBJECTS_LIST = 'GET_INVALSI_SUBJECTS_LIST';
export const GET_INVALSI_SUBJECTS_LIST_SUCCESS = 'GET_INVALSI_SUBJECTS_LIST_SUCCESS';
export const GET_INVALSI_SUBJECTS_LIST_UNAUTHORIZED = 'GET_INVALSI_SUBJECTS_LIST_UNAUTHORIZED';
export const GET_INVALSI_SUBJECTS_LIST_FAILURE = 'GET_INVALSI_SUBJECTS_LIST_FAILURE';
export const GET_INVALSI_YEARS_LIST = 'GET_INVALSI_YEARS_LIST';
export const GET_INVALSI_YEARS_LIST_SUCCESS = 'GET_INVALSI_YEARS_LIST_SUCCESS';
export const GET_INVALSI_YEARS_LIST_UNAUTHORIZED = 'GET_INVALSI_YEARS_LIST_UNAUTHORIZED';
export const GET_INVALSI_YEARS_LIST_FAILURE = 'GET_INVALSI_YEARS_LIST_FAILURE';
export const GET_INVALSI_ITEM_TYPES = 'GET_INVALSI_ITEM_TYPES';
export const GET_INVALSI_ITEM_TYPES_SUCCESS = 'GET_INVALSI_ITEM_TYPES_SUCCESS';
export const GET_INVALSI_ITEM_TYPES_FAILURE = 'GET_INVALSI_ITEM_TYPES_FAILURE';

//invalsi homework actions
export const GET_INVALSI_HOMEWORK_LIST = 'GET_INVALSI_HOMEWORK_LIST';
export const GET_INVALSI_HOMEWORK_LIST_SUCCESS = 'GET_INVALSI_HOMEWORK_LIST_SUCCESS';
export const GET_INVALSI_HOMEWORK_LIST_UNAUTHORIZED = 'GET_INVALSI_HOMEWORK_LIST_UNAUTHORIZED';
export const GET_INVALSI_HOMEWORK_LIST_FAILURE = 'GET_INVALSI_HOMEWORK_LIST_FAILURE';
export const GET_MORE_INVALSI_HOMEWORK_LIST = 'GET_MORE_INVALSI_HOMEWORK_LIST_';
export const GET_MORE_INVALSI_HOMEWORK_LIST_SUCCESS = 'GET_MORE_INVALSI_HOMEWORK_LIST_SUCCESS';
export const GET_MORE_INVALSI_HOMEWORK_LIST_FAILURE = 'GET_MORE_INVALSI_HOMEWORK_LIST_FAILURE';
export const GET_MORE_INVALSI_HOMEWORK_LIST_UNAUTHORIZED = 'GET_MORE_INVALSI_HOMEWORK_LIST_UNAUTHORIZED';

//invalsi exercise actions
export const GET_INVALSI_EXERCISE_LIST = 'GET_INVALSI_EXERCISE_LIST';
export const GET_INVALSI_EXERCISE_LIST_SUCCESS = 'GET_INVALSI_EXERCISE_LIST_SUCCESS';
export const GET_MORE_INVALSI_EXERCISE_LIST = 'GET_MORE_INVALSI_EXERCISE_LIST';
export const GET_MORE_INVALSI_EXERCISE_LIST_SUCCESS = 'GET_MORE_INVALSI_EXERCISE_LIST_SUCCESS';
export const GET_INVALSI_EXERCISE_LIST_UNAUTHORIZED = 'GET_INVALSI_EXERCISE_LIST_UNAUTHORIZED';
export const GET_INVALSI_EXERCISE_LIST_FAILURE = 'GET_INVALSI_EXERCISE_LIST_FAILURE';
export const INVALSI_FILTERS_CHANGE = 'INVALSI_FILTERS_CHANGE';

//special actions
export const GET_SPECIAL_EXERCISES = 'GET_SPECIAL_EXERCISES';
export const GET_SPECIAL_EXERCISES_SUCCESS = 'GET_SPECIAL_EXERCISES_SUCCESS';
export const GET_MORE_SPECIAL_EXERCISES = 'GET_MORE_SPECIAL_EXERCISES';
export const GET_MORE_SPECIAL_EXERCISES_SUCCESS = 'GET_MORE_SPECIAL_EXERCISES_SUCCESS';
export const GET_SPECIAL_EXERCISES_UNAUTHORIZED = 'GET_SPECIAL_EXERCISES_UNAUTHORIZED';
export const GET_SPECIAL_EXERCISES_FAILURE = 'GET_SPECIAL_EXERCISES_FAILURE';
export const GET_SPECIAL_SUBJECTS_LIST = 'GET_SPECIAL_SUBJECTS_LIST';
export const GET_SPECIAL_SUBJECTS_LIST_SUCCESS = 'GET_SPECIAL_SUBJECTS_LIST_SUCCESS';
export const GET_SPECIAL_SUBJECTS_LIST_UNAUTHORIZED = 'GET_SPECIAL_SUBJECTS_LIST_UNAUTHORIZED';
export const GET_SPECIAL_SUBJECTS_LIST_FAILURE = 'GET_SPECIAL_SUBJECTS_LIST_FAILURE';
export const GET_SPECIAL_ORIGINS_LIST = 'GET_SPECIAL_ORIGINS_LIST';
export const GET_SPECIAL_ORIGINS_LIST_SUCCESS = 'GET_SPECIAL_ORIGINS_LIST_SUCCESS';
export const GET_SPECIAL_ORIGINS_LIST_FAILURE = 'GET_SPECIAL_ORIGINS_LIST_FAILURE';
export const GET_SPECIAL_ORIGINS_LIST_UNAUTHORIZED = 'GET_SPECIAL_ORIGINS_LIST_UNAUTHORIZED';
export const GET_SPECIAL_ITEMTYPES_LIST = 'GET_SPECIAL_ITEMTYPES_LIST';
export const GET_SPECIAL_ITEMTYPES_LIST_SUCCESS = 'GET_SPECIAL_ITEMTYPES_LIST_SUCCESS';
export const GET_SPECIAL_ITEMTYPES_LIST_FAILURE = 'GET_SPECIAL_ITEMTYPES_LIST_FAILURE';
export const GET_SPECIAL_ITEMTYPES_LIST_UNAUTHORIZED = 'GET_SPECIAL_ITEMTYPES_LIST_UNAUTHORIZED';
export const GET_SPECIAL_CONTENT_TAXONOMY = 'GET_SPECIAL_CONTENT_TAXONOMY';
export const GET_SPECIAL_CONTENT_TAXONOMY_SUCCESS = 'GET_SPECIAL_CONTENT_TAXONOMY_SUCCESS';
export const GET_SPECIAL_CONTENT_TAXONOMY_FAILURE = 'GET_SPECIAL_CONTENT_TAXONOMY_FAILURE';
export const GET_SPECIAL_HOMEWORKS_LIST = 'GET_SPECIAL_HOMEWORKS_LIST';
export const GET_SPECIAL_HOMEWORKS_LIST_SUCCESS = 'GET_SPECIAL_HOMEWORKS_LIST_SUCCESS';
export const GET_SPECIAL_HOMEWORKS_LIST_UNAUTHORIZED = 'GET_SPECIAL_HOMEWORKS_LIST_UNAUTHORIZED';
export const GET_SPECIAL_HOMEWORKS_LIST_FAILURE = 'GET_SPECIAL_HOMEWORKS_LIST_FAILURE';
export const GET_MORE_SPECIAL_HOMEWORKS_LIST = 'GET_MORE_SPECIAL_HOMEWORKS_LIST_';
export const GET_MORE_SPECIAL_HOMEWORKS_LIST_SUCCESS = 'GET_MORE_SPECIAL_HOMEWORKS_LIST_SUCCESS';
export const GET_MORE_SPECIAL_HOMEWORKS_LIST_FAILURE = 'GET_MORE_SPECIAL_HOMEWORKS_LIST_FAILURE';
export const EXERCISES_SPECIAL_FILTERS_CHANGE = 'EXERCISES_SPECIAL_FILTERS_CHANGE';
